import { render } from "./index.vue?vue&type=template&id=22ae7cda&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-22ae7cda"

export default script